import {
  CalendarOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  FileTextOutlined,
  PictureOutlined,
} from '@ant-design/icons'
import { Button, Card, Flex, Tag, Tooltip, Typography } from 'antd'
import { PropertyActivityItem } from 'Modules'

import MarkdownEditor from 'component/markdown-editor/markdown-editor'
import { FEATURE } from 'constants/feature'
import { getActivityTypeIcon } from 'constants/property-activities'
import { usePermission } from 'hooks/use-permission'
import { formatShortDate } from 'utils/format-time'

const { Text } = Typography

interface ActivityCardProps {
  activity: PropertyActivityItem
  onView: (activity: PropertyActivityItem) => void
  onEdit: (activity: PropertyActivityItem) => void
  onDelete: (activity: PropertyActivityItem) => void
}

export const ActivityCard = ({ activity, onView, onEdit, onDelete }: ActivityCardProps) => {
  const { canCRUD } = usePermission()
  const canEdit = canCRUD(FEATURE.PROPERTY_ACTIVITIES)
  const typeIcon = getActivityTypeIcon(activity)
  const imagesCount = activity.images?.length ?? 0

  return (
    <Card className="property-activities__activity-card" styles={{ body: { padding: 20 } }}>
      <Flex gap={16} align="flex-start">
        <div className="property-activities__activity-icon">
          {typeIcon ? <img src={typeIcon} alt="" /> : <FileTextOutlined />}
        </div>

        <Flex vertical gap={6} style={{ flex: 1, minWidth: 0 }}>
          <Flex gap={8} align="center" wrap="wrap">
            <Text strong style={{ fontSize: 15 }}>
              {activity.title}
            </Text>
            {/* BE chưa support status — tạm hiển thị "Published" cho mọi activity. */}
            <Tag color="default" className="property-activities__status-tag is-published">
              Published
            </Tag>
          </Flex>

          <MarkdownEditor disabled value={activity.description} placeholder="No description" />

          <Flex gap={20} align="center" wrap="wrap" style={{ marginTop: 4 }}>
            <Flex gap={6} align="center">
              <CalendarOutlined style={{ color: '#9ca3af', fontSize: 12 }} />
              <Text type="secondary" style={{ fontSize: 12 }}>
                {formatShortDate(activity.timeline)}
              </Text>
            </Flex>
            <Flex gap={6} align="center">
              <PictureOutlined style={{ color: '#9ca3af', fontSize: 12 }} />
              <Text type="secondary" style={{ fontSize: 12 }}>
                {imagesCount} {imagesCount === 1 ? 'file' : 'files'}
              </Text>
            </Flex>
          </Flex>
        </Flex>

        <Flex gap={4}>
          <Tooltip title="View">
            <Button
              type="text"
              icon={<EyeOutlined style={{ color: '#3b82f6' }} />}
              onClick={() => onView(activity)}
            />
          </Tooltip>
          {canEdit && (
            <>
              <Tooltip title="Edit">
                <Button
                  type="text"
                  icon={<EditOutlined style={{ color: '#3b82f6' }} />}
                  onClick={() => onEdit(activity)}
                />
              </Tooltip>
              <Tooltip title="Delete">
                <Button
                  type="text"
                  icon={<DeleteOutlined style={{ color: '#ef4444' }} />}
                  onClick={() => onDelete(activity)}
                />
              </Tooltip>
            </>
          )}
        </Flex>
      </Flex>
    </Card>
  )
}
